<template>
  <div class="cm-wrap">

    <!-- Filtros -->
    <div class="filter-card">
      <div class="row">
        <div class="col-md-4">
          <label class="form-label">RUC</label>
          <input v-model="filtrosPendientes.ruc" class="form-control form-control-sm" placeholder="Buscar por RUC..." />
        </div>
        <div class="col-md-4">
          <label class="form-label">Razón Social</label>
          <input v-model="filtrosPendientes.nombre" class="form-control form-control-sm" placeholder="Buscar por nombre..." />
        </div>
        <div class="col-md-4">
          <label class="form-label">&nbsp;</label>
          <div class="filter-actions">
            <button class="btn-filter" @click="aplicarFiltros"><i class="bi bi-search"></i> Buscar</button>
            <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Acciones -->
    <div class="cm-actions mb-3">
      <button class="btn-add" @click="openModal()">
        <i class="bi bi-plus-lg"></i> Nueva Empresa
      </button>
    </div>

    <!-- Tabla (estándar: ESTANDAR_LISTADOS.md) -->
    <div>
      <div v-if="isLoading" class="cm-loading">
        <span class="spinner-border spinner-border-sm text-primary me-2"></span> Cargando...
      </div>
      <div v-else class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>Razón Social</th>
              <th>RUC</th>
              <th>Estado</th>
              <th>Sucursales</th>
              <th class="col-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="empresa in empresas" :key="empresa.id">
              <td class="celda-id">{{ empresa.id }}</td>
              <td class="celda-entidad"><div class="entidad-nombre" :title="empresa.nombre">{{ empresa.nombre }}</div></td>
              <td class="celda-id">{{ empresa.ruc }}</td>
              <td>
                <span :class="empresa.estado ? 'badge-activo' : 'badge-inactivo'">
                  {{ empresa.estado ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td>
                <button class="btn-icon btn-icon-view" @click="openModalDirecciones(empresa)" title="Gestionar sucursales" aria-label="Gestionar sucursales">
                  <i class="bi bi-geo-alt"></i>
                </button>
              </td>
              <td class="col-acciones">
                <button class="btn-icon btn-icon-edit" @click="openModal(empresa)" title="Editar" aria-label="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn-icon btn-icon-del" @click="eliminarEmpresa(empresa.id)" title="Eliminar" aria-label="Eliminar">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!empresas.length" class="empty-row">
              <td colspan="6">No se encontraron empresas</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Paginación en el backend (/getEmpresas?page=N&per_page=25) -->
      <PaginacionListado :pagina="paginaEmpresas" :total-paginas="totalPaginas" :total="totalEmpresas" :por-pagina="perPage"
        :en-pagina="empresas.length" :cargando="isLoading" etiqueta="empresas" @cambiar="cambiarPagina" />
    </div>

    <!-- Modal Nueva/Editar Empresa -->
    <div v-if="showModal"
      style="position:fixed;inset:0;background:rgba(0,0,0,0.45);display:flex;align-items:center;justify-content:center;z-index:1070;padding:16px;">
      <div class="cm-modal-box">
        <div class="cm-modal-header">
          <h5><i class="bi bi-briefcase me-2"></i>{{ empresaEdit.id ? 'Editar Empresa' : 'Nueva Empresa' }}</h5>
          <button class="cm-modal-close" @click="showModal = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="cm-modal-body">
          <form @submit.prevent="guardarEmpresa" class="cm-form">
            <div class="cm-form-grid">
              <div class="cm-field">
                <label class="cm-lbl">RUC <span class="cm-req">*</span></label>
                <input type="text" class="form-control" v-model="empresaEdit.ruc" required placeholder="Ej: 20123456789" />
              </div>
              <div class="cm-field">
                <label class="cm-lbl">Tipo <span class="cm-req">*</span></label>
                <select class="form-select" v-model="empresaEdit.tipo" required>
                  <option value="" disabled>Seleccione tipo</option>
                  <option value="INTERNA">Interna</option>
                  <option value="CLIENTE">Cliente</option>
                  <option value="CLIENTE_DE_CLIENTE">Cliente de Cliente</option>
                </select>
              </div>
              <div class="cm-field cm-full">
                <label class="cm-lbl">Razón Social <span class="cm-req">*</span></label>
                <input type="text" class="form-control" v-model="empresaEdit.nombre" required placeholder="Nombre legal de la empresa" />
              </div>
              <div class="cm-field cm-full">
                <label class="cm-lbl">Estado</label>
                <div class="estado-chips">
                  <label class="estado-chip" :class="{ active: empresaEdit.estado == 1 }">
                    <input type="radio" :value="1" v-model="empresaEdit.estado" /> <i class="bi bi-check-circle me-1"></i> Activo
                  </label>
                  <label class="estado-chip estado-chip-off" :class="{ active: empresaEdit.estado == 0 }">
                    <input type="radio" :value="0" v-model="empresaEdit.estado" /> <i class="bi bi-x-circle me-1"></i> Inactivo
                  </label>
                </div>
              </div>
            </div>
            <div class="cm-footer">
              <button type="button" class="cm-btn-cancel" @click="showModal = false">Cancelar</button>
              <button type="submit" class="cm-btn-save"><i class="bi bi-check-circle me-2"></i>Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal Sucursales -->
    <div v-if="showModalDirecciones" class="cm-modal-bg">
      <div class="cm-modal-box cm-modal-xl">
        <div class="cm-modal-header">
          <h5><i class="bi bi-geo-alt me-2"></i>Gestionar Sucursales</h5>
          <button class="cm-modal-close" @click="showModalDirecciones = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="cm-modal-body">

          <!-- Form sucursal -->
          <div class="sucursal-form-wrap">
            <div class="sucursal-form-title">
              <i class="bi bi-plus-circle me-2"></i>{{ editando ? 'Editar sucursal' : 'Nueva sucursal' }}
            </div>
            <form @submit.prevent="guardarDireccion">
              <div class="row g-3">
                <div class="col-lg-4">
                  <label class="cm-lbl">Nombre <span class="cm-req">*</span></label>
                  <input type="text" class="form-control form-control-sm" v-model="direccionEdit.nombre" required />
                </div>
                <div class="col-lg-8">
                  <label class="cm-lbl">Dirección <span class="cm-req">*</span></label>
                  <input type="text" class="form-control form-control-sm" v-model="direccionEdit.direccion" required />
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Departamento</label>
                  <select class="form-select form-select-sm" @change="cargarProvincias()" v-model="direccionEdit.departamento_id" required>
                    <option value="" disabled>Seleccione</option>
                    <option v-for="item in departamentos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Provincia</label>
                  <select class="form-select form-select-sm" @change="cargarDistritos()" v-model="direccionEdit.provincia_id" required>
                    <option value="" disabled>Seleccione</option>
                    <option v-for="item in provincias" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Distrito</label>
                  <select class="form-select form-select-sm" v-model="direccionEdit.distrito_id" required>
                    <option value="" disabled>Seleccione</option>
                    <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Nombre Contacto</label>
                  <input type="text" class="form-control form-control-sm" v-model="direccionEdit.nombre_contacto" />
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Área de Atención</label>
                  <input type="text" class="form-control form-control-sm" v-model="direccionEdit.cargo_contacto" />
                </div>
                <div class="col-lg-4">
                  <label class="cm-lbl">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" v-model="direccionEdit.telefono_contacto" />
                </div>
              </div>
              <div class="cm-footer mt-3">
                <button type="button" class="cm-btn-cancel" @click="resetDireccion()">Cancelar</button>
                <button type="submit" class="cm-btn-save">
                  <i class="bi bi-check-circle me-2"></i>{{ editando ? 'Actualizar' : 'Guardar Sucursal' }}
                </button>
              </div>
            </form>
          </div>

          <!-- Tabla sucursales -->
          <div class="mt-3">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nombre</th><th>Dirección</th><th>Depto.</th><th>Provincia</th><th>Distrito</th>
                    <th>Contacto</th><th>Área</th><th class="col-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in paginar(direcciones)" :key="d.id">
                    <td class="celda-entidad"><div class="entidad-nombre" :title="d.nombre">{{ d.nombre }}</div></td>
                    <td class="celda-entidad"><div class="entidad-nombre" :title="d.direccion">{{ d.direccion }}</div></td>
                    <td>{{ d.departamento_nombre }}</td>
                    <td>{{ d.provincia_nombre }}</td>
                    <td>{{ d.distrito_nombre }}</td>
                    <td>{{ d.nombre_contacto }} {{ d.telefono_contacto }}</td>
                    <td>{{ d.cargo_contacto }}</td>
                    <td class="col-acciones">
                      <button class="btn-icon btn-icon-edit" @click="editarDireccion(d)" title="Editar" aria-label="Editar"><i class="bi bi-pencil"></i></button>
                      <button class="btn-icon btn-icon-del" @click="eliminarDireccion(d.id)" title="Eliminar" aria-label="Eliminar"><i class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                  <tr v-if="!direcciones.length" class="empty-row">
                    <td colspan="8">No se encontraron sucursales</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(direcciones)" :total-paginas="totalPaginasDe(direcciones)"
              :total="direcciones.length" :por-pagina="porPagina" :en-pagina="paginar(direcciones).length"
              etiqueta="sucursales" @cambiar="pagina = $event" />
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionLocal from '@/mixins/paginacionLocal'

export default {
  name: 'CompanyPage',
  components: { PaginacionListado },
  // El mixin (pagina / porPagina) pagina en local la tabla de sucursales del modal;
  // las empresas se paginan en el backend con paginaEmpresas / perPage.
  mixins: [paginacionLocal],
  data() {
    return {
      empresas: [],
      paginaEmpresas: 1,
      perPage: 25,
      totalPaginas: 1,
      totalEmpresas: 0,
      filtroRuc: '',
      filtroNombre: '',
      filtrosPendientes: { ruc: '', nombre: '' },
      isLoading: false,
      departamentos: [],
      provincias: [],
      distritos: [],
      direcciones: [],
      editando: false,
      editIndex: null,
      showModal: false,
      showModalDirecciones: false,
      empresaEdit: { id: null, nombre: '', ruc: '', tipo: '', estado: 1 },
      empresaId: null,
      direccionEdit: {
        empresa_id: null,
        nombre: '',
        direccion: '',
        distrito_id: null,
        nombre_contacto: '',
        cargo_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
      },
    }
  },
  mounted() {
    this.cargarEmpresas();
    this.cargarDepartamentos();
  },
  methods: {
    async cargarEmpresas() {
      this.isLoading = true;
      try {
        const response = await axios.get('/getEmpresas', {
          params: { page: this.paginaEmpresas, per_page: this.perPage, ruc: this.filtroRuc, nombre: this.filtroNombre }
        });
        this.empresas = response.data.data;
        this.totalPaginas = response.data.last_page;
        this.totalEmpresas = response.data.total;
      } catch (error) {
        console.error('Error al cargar empresas', error)
      } finally {
        this.isLoading = false;
      }
    },
    async cargarDepartamentos() {
      try {
        this.provincias = [];
        const response = await axios.get('/departamentos')
        this.departamentos = response.data
      } catch (error) {
        console.error('Error al cargar departamentos', error)
      }
    },
    async cargarProvincias() {
      try {
        this.distritos = []
        const response = await axios.get('/provinciasByDepartamentos/' + this.direccionEdit.departamento_id)
        this.provincias = response.data
      } catch (error) {
        console.error('Error al cargar provincias', error)
      }
    },
    async cargarDistritos() {
      try {
        const response = await axios.get('/distritosByProvincias/' + this.direccionEdit.provincia_id)
        this.distritos = response.data
      } catch (error) {
        console.error('Error al cargar distritos', error)
      }
    },
    openModal(empresa) {
      this.empresaEdit = empresa
        ? { ...empresa }
        : { id: null, nombre: '', ruc: '', tipo: '', estado: 1 }
      this.showModal = true
    },
    openModalDirecciones(empresa) {
      this.resetDireccion()
      this.empresaId = empresa.id
      this.direccionEdit.empresa_id = empresa.id
      this.pagina = 1;
      this.showModalDirecciones = true;
      this.cargarDirecciones();
    },
    resetDireccion() {
      this.editando = false;
      this.editId = null;
      this.direccionEdit = { empresa_id: this.direccionEdit.empresa_id, nombre: '', direccion: '', distrito_id: null, nombre_contacto: '', cargo_contacto: '', telefono_contacto: '', email_contacto: '' };
    },
    async guardarEmpresa() {
      try {
        if (this.empresaEdit.id) {
          await axios.put(`empresas/${this.empresaEdit.id}`, this.empresaEdit)
        } else {
          await axios.post('empresas', this.empresaEdit)
        }
        this.showModal = false
        this.cargarEmpresas()
      } catch (error) {
        console.error('Error al guardar empresa', error)
      }
    },
    async eliminarEmpresa(id) {
      if (confirm('¿Seguro que quieres eliminar esta empresa?')) {
        try {
          await axios.delete(`empresas/${id}`)
          this.cargarEmpresas()
        } catch (error) {
          console.error('Error al eliminar empresa', error)
        }
      }
    },
    async cargarDirecciones() {
      try {
        const response = await axios.get('empresa-sucursales/' + this.empresaId);
        this.direcciones = response.data;
      } catch (error) {
        console.error('Error al cargar direcciones:', error);
      }
    },
    async guardarDireccion() {
      try {
        if (this.editando) {
          await axios.put(`sucursales/${this.editId}`, this.direccionEdit);
        } else {
          await axios.post('sucursales', this.direccionEdit);
        }
        this.resetDireccion();
        this.cargarDirecciones();
      } catch (error) {
        console.error('Error al guardar dirección:', error);
      }
    },
    async editarDireccion(direccion) {
      this.direccionEdit = { ...direccion };
      this.editando = true;
      this.editId = direccion.id;
      await this.cargarProvincias()
      await this.cargarDistritos()
    },
    async eliminarDireccion(id) {
      try {
        await axios.delete(`sucursales/${id}`);
        this.cargarDirecciones();
      } catch (error) {
        console.error('Error al eliminar dirección:', error);
      }
    },
    cambiarPagina(nueva) {
      if (nueva < 1 || nueva > this.totalPaginas) return;
      this.paginaEmpresas = nueva;
      this.cargarEmpresas();
    },
    aplicarFiltros() {
      this.filtroRuc = this.filtrosPendientes.ruc;
      this.filtroNombre = this.filtrosPendientes.nombre;
      this.paginaEmpresas = 1;
      this.cargarEmpresas();
    },
    limpiarFiltros() {
      this.filtrosPendientes.ruc = '';
      this.filtrosPendientes.nombre = '';
      this.filtroRuc = '';
      this.filtroNombre = '';
      this.paginaEmpresas = 1;
      this.cargarEmpresas();
    }
  },
}
</script>

<style scoped>
.cm-wrap { padding: 4px 0; }
.cm-loading { padding: 32px; text-align: center; color: #9e9e9e; font-size: 0.85rem; }

/* ── Top actions ── */
.cm-actions { display: flex; justify-content: flex-end; }

/* ── Modal shell ── */
.cm-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 1070; padding: 16px; }
.cm-modal-box { background: #fff; border-radius: 12px; box-shadow: 0 20px 48px rgba(15,23,42,0.18); width: 100%; max-width: 560px; overflow: hidden; max-height: calc(100vh - 2rem); display: flex; flex-direction: column; }
.cm-modal-xl { max-width: min(1140px, calc(100vw - 2rem)); }
.cm-modal-header { background: #fff; padding: 14px 20px; border-bottom: 1px solid #eceef3; display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-shrink: 0; }
.cm-modal-header h5 { margin: 0; font-size: 1rem; font-weight: 600; line-height: 1.4; color: #2b2f3a !important; }
.cm-modal-close { background: transparent; border: none; color: #8592a3; border-radius: 8px; width: 32px; height: 32px; margin-right: -6px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: background 0.15s, color 0.15s; }
.cm-modal-close:hover { background: #f0f2f5; color: #384551; }
.cm-modal-body { padding: 20px; overflow-y: auto; }

/* ── Form grid ── */
.cm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 18px; }
.cm-field { display: flex; flex-direction: column; gap: 6px; }
.cm-full { grid-column: 1 / -1; }
.cm-lbl { font-size: 0.72rem; font-weight: 700; color: #546e7a; text-transform: uppercase; letter-spacing: 0.5px; }
.cm-req { color: #e53935; }

/* ── Estado chips ── */
.estado-chips { display: flex; gap: 8px; }
.estado-chip { flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px; padding: 8px 12px; border: 2px solid #e0e3f5; border-radius: 8px; background: #fafbff; cursor: pointer; font-size: 0.85rem; font-weight: 500; color: #616161; transition: all 0.2s; }
.estado-chip input { display: none; }
.estado-chip.active { border-color: #3f51b5; background: #e8eaf6; color: #3f51b5; font-weight: 700; }
.estado-chip-off.active { border-color: #c62828; background: #ffebee; color: #c62828; }

/* ── Footer ── */
.cm-footer { display: flex; gap: 10px; justify-content: flex-end; padding-top: 18px; border-top: 1px solid #f0f1fa; margin-top: 4px; }
.cm-btn-cancel { background: #f5f5f5; color: #616161; border: 1px solid #e0e0e0; border-radius: 9px; padding: 9px 20px; font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: background 0.15s; }
.cm-btn-cancel:hover { background: #eeeeee; }
.cm-btn-save { background: linear-gradient(135deg, #3f51b5 0%, #283593 100%); color: #fff; border: none; border-radius: 9px; padding: 9px 22px; font-size: 0.85rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; transition: opacity 0.15s; }
.cm-btn-save:hover { opacity: 0.9; }

/* ── Sucursal form ── */
.sucursal-form-wrap { background: #f8f9ff; border: 1px solid #e8eaf6; border-radius: 10px; padding: 18px 20px; margin-bottom: 4px; }
.sucursal-form-title { font-size: 0.78rem; font-weight: 700; color: #3f51b5; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 14px; display: flex; align-items: center; }
</style>
